import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const CheckIconCircle = ({
  width = 14,
  height = 14,
  className,
  color,
  decorative = false,
  ariaLabel = "Elemento selezionato",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 12 12"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        d="M10 3L4.5 8.5L2 6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
